import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Files } from '@/components/ActionPlan/UploadFile/Files';
import * as S from './styles';

interface UploadFileProps {
	origin_table: string;
	table_origin_id: string;
}

export function UploadFile({ origin_table, table_origin_id }: Readonly<UploadFileProps>): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Row gutter={[0, 20]}>
					<Col span={24}>
						<S.InputLabel>{I18n.get('Attachments')}</S.InputLabel>
					</Col>
					<Col>
						<Form.Item name="attachments">
							<Files origin_table={origin_table} table_origin_id={table_origin_id} />
						</Form.Item>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
